import { useGetCardsQuery } from '@/modules/transaction/queries/useGetCards.query';
import useAuthStore from '@/modules/user/stores/useAuth.store';

const useIsCardVerificationAvailable = (): boolean => {
  const { user } = useAuthStore();
  const { employeePendingOpenCard, employeeActiveCard } = useGetCardsQuery(user?.employee?.id);

  const verificationCard = employeePendingOpenCard || employeeActiveCard;

  if (!verificationCard) {
    return false;
  }

  return Boolean(verificationCard.mailedDate);
};

export default useIsCardVerificationAvailable;
